#import "../list/TravelSectionAuthDataFragment.graphql"
#import "../../../common/graphql/EntityDocumentsFields.graphql"
#import "../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
#import "./FormView/Trips/TripModal/TripFragment.graphql"

query TravelAuthorizationRefresh($id: UUID!) {
  travelAuthorization(id: $id) {
    __typename
    id
    _urgencyLevel
    stampedEntityDocumentId
    _rowTimestamp
    _isUpdatable
    _isDeletable
    _isOverBudget
    _isDistributionUpdateAllowed
    _isRevisable
    _isAccountingEntry
    _isHistory
    _isStampAllowed
    _isUnstampAllowed
    _isRevisable
    _isAccountingEntryStampedComplete
    _isTransactionCancelled
    _accountingStampDate
    _accountingStampUserName
    _accountingStampTransactionReference
    _isPlanningPhase
    travelAuthorizationNumber
    tripPurpose
    comment
    travelAuthorizationDate
    bookingFee
    departmentId
    currencyId
    _isTripMovementAllowed
    currency {
      isoCode
      name
      currencySymbol
    }
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    _suppliers
    isPersonalTravelAuthorization
    businessUnitId
    businessUnit {
      name
      _isProductionBusinessUnit
      _isCorporateWorkgroupRequired
    }
    corporateWorkgroupId
    supplierId
    travelAuthorizationRevisionHistoriesByTaGroupId(
      orderBy: DATE_REQUESTED_DESC
      filter: { id: { notEqualTo: $id } }
    ) {
      nodes {
        id
        travelAuthorizationNumber
        travelPlan
        dateRequested
        taTotal
        tripPurpose
        requesterName
      }
    }
    supplier {
      id
      _fullName
      _isAliasOriginalNameViewable
      _isAliasInvoked
      _isUpdatable
      _isApproved
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
        nodes {
          isPrimary
          addressLine1
          addressLine2
          cityName
          postalCode
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          telephoneNumber
          emailAddress
        }
      }
      vendorNumber
      vendorServiceRate
    }
    budgetAmount
    controlTotalAmount
    ...TravelAuthorizationTravelSectionFragment
    trips(orderBy: [TRAVELER_REFERENCE_NAME_ASC, TRIP_LOCATOR_ASC]) {
      nodes {
        _requiredApprovalDocuments
        _isApprovalDocumentsRequired
        entityDocumentsByEntityId(
          orderBy: [
            DOCUMENT_POSITION_ASC
            _CREATED_DATE_DESC
            FILE_REFERENCE_ASC
          ]
        ) {
          nodes {
            ...EntityDocumentsFields
          }
          totalCount
        }
        tripHistoriesByEntityId {
          nodes {
            crudOperation
            pointInTimeDate
            tenantUserName
          }
        }
        notesByEntityId(orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            _createdByUserName
            _createdDate
            noteComment
            isShared
            _isUpdatable
            _rowTimestamp
            _isDeletable
          }
        }
        id
        _rowTimestamp
        tripLocator
        travelerReferenceName
        accountReference
        airfareAmount
        accommodationAmount
        transportationAmount
        vehicleRentalAmount
        trainAmount
        otherAmount
        controlTotalAmount
        _isOverBudget
        budgetAmount
        incidentalAmount
        tripItems {
          nodes {
            ...TripItemFragment
          }
        }
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
      totalCount
    }
    travelAuthorizationHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _createdDate
        createdByUser
        _rowTimestamp
      }
    }
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    _requiredApprovalDocuments
    _isProtected
    isDraft
    _isStagedApprovalRequest
    _isApprovalRevocable
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    _isCloningAllowed
    _emailDocument {
      ...EmailDocumentFields
    }
    _planEmailDocument {
      ...EmailDocumentFields
    }
    travelPlanEmailDocumentsByEntityId: emailDocumentsByEntityId(
      orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]
      filter: { _isTravelPlanEmail: { equalTo: true } }
    ) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
    travelAuthorizationEmailDocumentsByEntityId: emailDocumentsByEntityId(
      orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]
      filter: { _isTravelPlanEmail: { equalTo: false } }
    ) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
    _isNonAmountUpdatableAfterApproval
  }
}
